export default __webpack_public_path__ + "static/media/Designer.abec1f0a.png";